/**
 * Card with an inline header (title + optional description and right slot).
 * Used to wrap tables / charts / accordion lists so they share a chrome.
 */

import React from 'react';
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';

export default function SectionCard({
  title,
  description,
  rightSlot,
  children,
  contentSx = {},
  sx = {},
}) {
  return (
    <Card sx={sx}>
      {(title || rightSlot) && (
        <Box
          sx={{
            px: 2.5,
            py: 1.75,
            borderBottom: '1px solid',
            borderColor: 'divider',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Stack sx={{ flex: 1, minWidth: 0 }}>
            {title && (
              <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                {title}
              </Typography>
            )}
            {description && (
              <Typography variant="caption" color="text.secondary">
                {description}
              </Typography>
            )}
          </Stack>
          {rightSlot}
        </Box>
      )}
      <CardContent sx={{ p: 2.5, ...contentSx }}>{children}</CardContent>
    </Card>
  );
}
